import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type DispatchLoadMutationVariables = Types.Exact<{
  input: Types.DispatchLoadInput;
}>;


export type DispatchLoadMutation = { __typename?: 'Mutation', dispatchLoad: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UndoLoadDispatchMutationVariables = Types.Exact<{
  input: Types.UndoLoadDispatchInput;
}>;


export type UndoLoadDispatchMutation = { __typename?: 'Mutation', undoLoadDispatch: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteDeliveryMutationVariables = Types.Exact<{
  input: Types.CompleteDeliveryInput;
}>;


export type CompleteDeliveryMutation = { __typename?: 'Mutation', completeDelivery: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UndoDeliveryCompletionMutationVariables = Types.Exact<{
  input: Types.UndoDeliveryCompletionInput;
}>;


export type UndoDeliveryCompletionMutation = { __typename?: 'Mutation', undoDeliveryCompletion: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordStopDeliveredMutationVariables = Types.Exact<{
  input: Types.RecordStopDeliveredInput;
}>;


export type RecordStopDeliveredMutation = { __typename?: 'Mutation', recordStopDelivered: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordStopRefusedMutationVariables = Types.Exact<{
  input: Types.RecordStopRefusedInput;
}>;


export type RecordStopRefusedMutation = { __typename?: 'Mutation', recordStopRefused: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RecordStopPartiallyDeliveredMutationVariables = Types.Exact<{
  input: Types.RecordStopPartiallyDeliveredInput;
}>;


export type RecordStopPartiallyDeliveredMutation = { __typename?: 'Mutation', recordStopPartiallyDelivered: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearStopOutcomeMutationVariables = Types.Exact<{
  input: Types.ClearStopOutcomeInput;
}>;


export type ClearStopOutcomeMutation = { __typename?: 'Mutation', clearStopOutcome: { __typename?: 'DeliveryPayload', delivery?: { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type LogisticsDeliveryStateFieldsFragment = { __typename?: 'DeliveryStateData', tenantId: string, loadId: string, isDispatched: boolean, isCompleted: boolean, updatedAt: Types.TDateISO, updatedBy: string, stopOutcomes: Array<{ __typename?: 'StopOutcomeStateData', routeStopId: string, kind: Types.StopOutcomeKind, note?: string | null, recordedAt: Types.TDateISO, recordedBy: string, orders: Array<{ __typename?: 'StopOutcomeOrderQuantityStateData', orderId: string, deliveredQuantity: number, refusedQuantity: number }> }> };

export const LogisticsDeliveryStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsDeliveryStateFields"});
export const DispatchLoadDocument = new TypedDocumentString(`
    mutation DispatchLoad($input: DispatchLoadInput!) {
  dispatchLoad(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const UndoLoadDispatchDocument = new TypedDocumentString(`
    mutation UndoLoadDispatch($input: UndoLoadDispatchInput!) {
  undoLoadDispatch(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const CompleteDeliveryDocument = new TypedDocumentString(`
    mutation CompleteDelivery($input: CompleteDeliveryInput!) {
  completeDelivery(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const UndoDeliveryCompletionDocument = new TypedDocumentString(`
    mutation UndoDeliveryCompletion($input: UndoDeliveryCompletionInput!) {
  undoDeliveryCompletion(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const RecordStopDeliveredDocument = new TypedDocumentString(`
    mutation RecordStopDelivered($input: RecordStopDeliveredInput!) {
  recordStopDelivered(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const RecordStopRefusedDocument = new TypedDocumentString(`
    mutation RecordStopRefused($input: RecordStopRefusedInput!) {
  recordStopRefused(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const RecordStopPartiallyDeliveredDocument = new TypedDocumentString(`
    mutation RecordStopPartiallyDelivered($input: RecordStopPartiallyDeliveredInput!) {
  recordStopPartiallyDelivered(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
export const ClearStopOutcomeDocument = new TypedDocumentString(`
    mutation ClearStopOutcome($input: ClearStopOutcomeInput!) {
  clearStopOutcome(input: $input) {
    delivery {
      ...LogisticsDeliveryStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LogisticsDeliveryStateFields on DeliveryStateData {
  tenantId
  loadId
  isDispatched
  isCompleted
  stopOutcomes {
    routeStopId
    kind
    note
    orders {
      orderId
      deliveredQuantity
      refusedQuantity
    }
    recordedAt
    recordedBy
  }
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    DispatchLoad: build.mutation<DispatchLoadMutation, DispatchLoadMutationVariables>({
      query: (variables) => ({ document: DispatchLoadDocument, variables })
    }),
    UndoLoadDispatch: build.mutation<UndoLoadDispatchMutation, UndoLoadDispatchMutationVariables>({
      query: (variables) => ({ document: UndoLoadDispatchDocument, variables })
    }),
    CompleteDelivery: build.mutation<CompleteDeliveryMutation, CompleteDeliveryMutationVariables>({
      query: (variables) => ({ document: CompleteDeliveryDocument, variables })
    }),
    UndoDeliveryCompletion: build.mutation<UndoDeliveryCompletionMutation, UndoDeliveryCompletionMutationVariables>({
      query: (variables) => ({ document: UndoDeliveryCompletionDocument, variables })
    }),
    RecordStopDelivered: build.mutation<RecordStopDeliveredMutation, RecordStopDeliveredMutationVariables>({
      query: (variables) => ({ document: RecordStopDeliveredDocument, variables })
    }),
    RecordStopRefused: build.mutation<RecordStopRefusedMutation, RecordStopRefusedMutationVariables>({
      query: (variables) => ({ document: RecordStopRefusedDocument, variables })
    }),
    RecordStopPartiallyDelivered: build.mutation<RecordStopPartiallyDeliveredMutation, RecordStopPartiallyDeliveredMutationVariables>({
      query: (variables) => ({ document: RecordStopPartiallyDeliveredDocument, variables })
    }),
    ClearStopOutcome: build.mutation<ClearStopOutcomeMutation, ClearStopOutcomeMutationVariables>({
      query: (variables) => ({ document: ClearStopOutcomeDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useDispatchLoadMutation, useUndoLoadDispatchMutation, useCompleteDeliveryMutation, useUndoDeliveryCompletionMutation, useRecordStopDeliveredMutation, useRecordStopRefusedMutation, useRecordStopPartiallyDeliveredMutation, useClearStopOutcomeMutation } = injectedRtkApi;
